import { render } from "./Result.vue?vue&type=template&id=55a1a365&scoped=true&ts=true"
import script from "./Result.vue?vue&type=script&setup=true&lang=ts"
export * from "./Result.vue?vue&type=script&setup=true&lang=ts"

import "./Result.vue?vue&type=style&index=0&id=55a1a365&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src231289078/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a1a365"],['__file',"src/components/sgre/Result.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55a1a365"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55a1a365', __exports__)) {
    console.log('reload')
    api.reload('55a1a365', __exports__)
  }
  
  module.hot.accept("./Result.vue?vue&type=template&id=55a1a365&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('55a1a365', render)
  })

}


export default __exports__